import { useState } from 'react'
import { ResumeCritiqueStatuses } from 'builder/modules/resumeCritiqueReview'
import { useI18n } from 'builder/hooks/useI18n'
import expertsDefault from './images/expertsDefault.png'
import expertsHovered from './images/expertsHovered.png'
import REVIEW_AVATAR from './images/review-avatar.png'
import {
  BadgeBanner as Banner,
  BadgeInfoContainer,
  Content,
  GenerateButton,
  ImageContainer,
  ImageDefault,
  ImageHovered,
  ImageDefaultNoHover,
  Spinner,
  RightArrow,
  ReviewAvatar,
  StarContainer,
  Star,
  ErrorClose,
  ErrorContainer,
  Close,
} from './styles'

interface BadgeBannerProps {
  sendResumeToReview: () => void
  critiqueReviewStatus?: `${ResumeCritiqueStatuses}`
  viewResumeCritiqueReview: () => void
}

const CritiqueReviewBanner = ({
  sendResumeToReview,
  critiqueReviewStatus,
  viewResumeCritiqueReview,
}: BadgeBannerProps) => {
  const { i18n } = useI18n()
  const [hideBanner, setHideBanner] = useState(false)

  return (
    <Banner
      $isError={critiqueReviewStatus === 'failed'}
      $reducePadding={!critiqueReviewStatus}
      $hide={hideBanner}
      data-testid="critique-review-banner"
    >
      <BadgeInfoContainer>
        {critiqueReviewStatus === 'pending' && <ImageDefaultNoHover src={expertsDefault} />}
        {!critiqueReviewStatus && (
          <ImageContainer>
            <ImageDefault src={expertsDefault} alt="Default Image" />
            <ImageHovered src={expertsHovered} alt="Hovered Image" />
          </ImageContainer>
        )}
        {critiqueReviewStatus === 'finished' && (
          <>
            <ReviewAvatar src={REVIEW_AVATAR} />
            <StarContainer>
              <Star />
            </StarContainer>
          </>
        )}
        {critiqueReviewStatus === 'pending' && <Spinner />}
        {critiqueReviewStatus === 'failed' && (
          <ErrorContainer>
            <ErrorClose />
          </ErrorContainer>
        )}
        <Content
          $addMarginRight={critiqueReviewStatus === 'pending'}
          $useMaxWidth={!critiqueReviewStatus}
          $isError={critiqueReviewStatus === 'failed'}
        >
          {!critiqueReviewStatus &&
            i18n.t('builder.critique_entry_points.critique_review_banner.no_status')}
          {critiqueReviewStatus === 'pending' &&
            i18n.t('builder.critique_entry_points.critique_review_banner.pending')}
          {critiqueReviewStatus === 'finished' &&
            i18n.t('builder.critique_entry_points.critique_review_banner.finished')}
          {critiqueReviewStatus === 'failed' &&
            i18n.t('builder.critique_entry_points.critique_review_banner.failed')}
        </Content>
        {critiqueReviewStatus === 'finished' && <RightArrow onClick={viewResumeCritiqueReview} />}
        {critiqueReviewStatus === 'failed' && <Close onClick={() => setHideBanner(true)} />}
      </BadgeInfoContainer>
      {!critiqueReviewStatus && (
        <GenerateButton onClick={sendResumeToReview}>
          {i18n.t('builder.critique_entry_points.critique_review_banner.send')}
        </GenerateButton>
      )}
    </Banner>
  )
}

export default CritiqueReviewBanner
